import { Pipe, PipeTransform } from '@angular/core';
import { NeskoAbVerteilerDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { translateName } from 'app/shared/functions/language.functions';
import { TranslateService } from '@ngx-translate/core';
import { GbGemeindeListEntry } from 'app/core/gb-api';

@Pipe({
  name: 'NeskoabGrundstuecknummerPipe'
})
export class NeskoabGrundstuecknummerPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: NeskoAbVerteilerDetailEntryMeta): string {
    let nummer = this.formatGemeinde(value.gemeinde);
    nummer += value.nummer;
    if (value.nummer2 !== '0' || value.nummer3 !== '0') {
      nummer += this.combineIfNotNull('-', value.nummer2);
    }
    if (value.nummer3 !== '0') {
      nummer += this.combineIfNotNull('-', value.nummer3);
    }
    return nummer;
  }

  private formatGemeinde(value: GbGemeindeListEntry) {
    let gemeinde = '';
    if (value != null) {
      gemeinde += translateName(value.name, this.translateService) + ' ';
      gemeinde += value.bfsNummer + this.combineIfNotNull('.', value.kreisNummer);
      gemeinde += '/';
    }
    return gemeinde;
  }

  private combineIfNotNull(delimiter: string, value: any) {
    if (value) {
      return delimiter + value.toString();
    }
    return '';
  }
}
